'use client';

import PopularArticles from '~/shared/components/header/components/popular-articles';
import TopRatedCategories from '~/shared/components/header/components/top-rated-categories';
import type { Locale } from '~/shared/constants';

import useBlogMenu from './use-blog-menu';

import './blog-menu.scss';

import pranaBgSvg from '~/assets/prana-bg.svg?url';

type BlogMenuProps = Readonly<{
  lng: Locale;
}>;

const BlogMenu = ({ lng, closeDropdown }: BlogMenuProps) => {
  const { popularArticles, topRatedCategories, loading, error, t } = useBlogMenu({ lng });

  return (
    <div className="blog-menu">
      <TopRatedCategories
        closeDropdown={closeDropdown}
        lng={lng}
        items={topRatedCategories}
        loading={loading}
        error={error}
        t={t}
      />
      <PopularArticles
        closeDropdown={closeDropdown}
        lng={lng}
        items={popularArticles}
        loading={loading}
        error={error}
        t={t}
      />
      <img src={pranaBgSvg} alt="" className="blog-menu__bg" />
    </div>
  );
};

export default BlogMenu;
